module.exports = __webpack_public_path__ + "static/media/reply.3ccdf637.svg";